import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6e30956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-editor" }
const _hoisted_2 = { class: "box-editor-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "box-editor-label" }, "上", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "box-editor-unit" }, "px", -1))
const _hoisted_5 = { class: "box-editor-right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "box-editor-label" }, "右", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "box-editor-unit" }, "px", -1))
const _hoisted_8 = { class: "box-editor-bottom" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "box-editor-label" }, "下", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "box-editor-unit" }, "px", -1))
const _hoisted_11 = { class: "box-editor-left" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "box-editor-label" }, "左", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "box-editor-unit" }, "px", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueTop) = $event)),
        type: "number",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args))),
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args)))
      }, null, 544), [
        [
          _vModelText,
          _ctx.valueTop,
          void 0,
          { number: true }
        ]
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.valueRight) = $event)),
        type: "number",
        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args))),
        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args)))
      }, null, 544), [
        [
          _vModelText,
          _ctx.valueRight,
          void 0,
          { number: true }
        ]
      ]),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.valueBottom) = $event)),
        type: "number",
        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args))),
        onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args)))
      }, null, 544), [
        [
          _vModelText,
          _ctx.valueBottom,
          void 0,
          { number: true }
        ]
      ]),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.valueLeft) = $event)),
        type: "number",
        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args))),
        onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args)))
      }, null, 544), [
        [
          _vModelText,
          _ctx.valueLeft,
          void 0,
          { number: true }
        ]
      ]),
      _hoisted_13
    ])
  ]))
}